import axios from "axios";
import { getAuthHeaders } from "../auth/util";
import { BetResult } from "./types";

const uri = process.env.REACT_APP_WANNABET_API;

export async function getHistory() {
  return (
    await axios.get<BetResult[]>(`${uri}/history/betting`, {
      headers: getAuthHeaders(),
    })
  ).data;
}
